import type { WorkspaceRole } from '../../context/WorkspaceContext'
import type { SelectOption } from '../Common'
import {
  OWNER_ONLY_ACTIONS,
  canSetWorkspaceActionToHelper,
  canSetWorkspaceActionToReadonly,
  type WorkspaceAction,
} from '../../utils/workspacePermissions'

export const WORKSPACE_PERMISSION_ROLE_OPTIONS: Array<SelectOption<WorkspaceRole>> = [
  { value: 'HELPER', label: 'Helper + members' },
  { value: 'READONLY', label: 'Read-only · View only' },
  { value: 'VIEWER', label: 'Viewer · Everyone' },
  { value: 'EDITOR', label: 'Editor + Admin' },
  { value: 'ADMIN', label: 'Admin only' },
]

export const getWorkspacePermissionRoleOptions = (action: WorkspaceAction) => {
  if (OWNER_ONLY_ACTIONS.has(action)) {
    return [{ value: 'OWNER' as WorkspaceRole, label: 'Owner only' }]
  }
  return WORKSPACE_PERMISSION_ROLE_OPTIONS.filter((option) => {
    if (option.value === 'HELPER') return canSetWorkspaceActionToHelper(action)
    if (option.value === 'READONLY') return canSetWorkspaceActionToReadonly(action)
    return true
  })
}

export const workspacePermissionSaveLabel = (isSaving: boolean) =>
  isSaving ? 'Saving...' : 'Save permissions'
